module.exports = __webpack_public_path__ + "media/logos/wsj-logo-white-small-f35ad7f4.png";